import { render, staticRenderFns } from "./vendorBrandMapping.vue?vue&type=template&id=3177b0fc&scoped=true"
import script from "./vendorBrandMapping.vue?vue&type=script&lang=js"
export * from "./vendorBrandMapping.vue?vue&type=script&lang=js"
import style0 from "./vendorBrandMapping.vue?vue&type=style&index=0&id=3177b0fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3177b0fc",
  null
  
)

export default component.exports